const API_BASE_URL = process.env.REACT_APP_API_BASE_URL_IMAGE;

export const fileURL = (path) => {
  const raw = String(path || "").trim();

  if (!raw) return null;

  if (raw.startsWith("http://") || raw.startsWith("https://")) {
    return raw;
  }

  if (raw.startsWith("/image/")) {
    return raw;
  }

  if (!API_BASE_URL) {
    return raw;
  }

  const cleanBase = API_BASE_URL.replace(/\/+$/, "");
  const cleanPath = raw.replace(/^\/+/, "");

  if (cleanPath.startsWith("uploads/")) {
    return `${cleanBase}/${cleanPath}`;
  }

  return `${cleanBase}/uploads/${cleanPath}`;
};